import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

//import { theme } from '@ecp/common/src/style/theme/default';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';

const BenefitChipRoot = styled(FlexBox)`
  padding: 0 4px;
  height: 19px;
  font-size: 12px;
  border-radius: 4px;
  color: white;
  background-color: ${({ item }) =>
    {
      if (item === '한정수량' || item === '대량구매') {
        return '#23A0B1';
      } else {
        return '#FF5624';
      }
    }
  };
`;

const GoodBenefitChip = ({ item }) => {
  return <BenefitChipRoot item={item}>{item}</BenefitChipRoot>;
};

GoodBenefitChip.propTypes = {
  item: PropTypes.string,
};

export default GoodBenefitChip;
